import Helper from './Helper';

class InteractiveSVGLink {
  constructor() {
    this.interactiveLinks = document.querySelectorAll('.interactive-link');
    this.interactiveLinksArray = Array.prototype.slice.call(this.interactiveLinks);

    this.bindEvents();
  }

  bindEvents() {
    this.interactiveLinksArray.forEach((link) => {
      link.addEventListener('click', (e) => {
        var href = link.getAttribute('data-url');

        if (!href.includes(window.location.hostname)) {
          window.open(href, '_blank');
        } else {
          window.open(href, '_self');
        }
        // window.location.replace(link.getAttribute('data-url'));
      });
    });
  }
}

export default InteractiveSVGLink;
